<template>
    <div class="pagination">
        <button class="btn-page" :disabled="value.loading || value.page == 1" @click="value.firstPage()"><i class="fa fa-chevron-left"></i><i class="fa fa-chevron-left"></i></button>
        <button class="btn-page" :disabled="value.loading || value.page == 1" @click="value.prevPage()"><i class="fa fa-chevron-left"></i></button>
        <button class="btn-page" v-bind:class="{'current-page': p == value.page}" v-for="p in buildPageArray(7)" @click="value.goPage(p)">
            {{ p }}
        </button>
        <button class="btn-page" :disabled="value.loading || value.page == value.pages" @click="value.nextPage()"><i class="fa fa-chevron-right"></i></button>
        <button class="btn-page" :disabled="value.loading || value.page == value.pages" @click="value.lastPage()"><i class="fa fa-chevron-right"></i><i class="fa fa-chevron-right"></i></button>
    </div>
</template>
<script>
    export default {
        name: 'pagination',
        props: {
            value: {
                required: true
            }
        },
        methods: {
            buildPageArray(num) {
                let start = 1;
                if (this.value.page > Math.round(num / 2)) {
                    start = this.value.page - Math.floor(num / 2);
                }
                let end = this.value.pages;
                if (this.value.page < (this.value.pages - Math.floor(num / 2))) {
                    end = this.value.page + Math.floor(num / 2);
                }
                let result = [];
                for (let i = start; i <= end; i++) {
                    result.push(i);
                }
                return result;
            }
        }
    };
</script>
